module.exports = __webpack_public_path__ + "img/progress.35e7c27f.png";